import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "title", "disabled"]

import SmIcon from '@/components/ui/SmIcon/SmIcon.vue';

import { IIconButtonProps } from '@/@types/components/ui/buttons';

import '@/components/ui/buttons/SmIconButton/style.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmIconButton',
  props: {
    nativeType: { default: 'button' },
    iconName: {},
    title: {},
    disabled: { type: Boolean, default: false },
    size: {},
    viewbox: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: $emits }) {

const $props = __props;





const onClick = () => {
  $emits('click')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: $props.nativeType,
    title: $props.title,
    class: "sm-icon-button",
    disabled: $props.disabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick()))
  }, [
    _createVNode(SmIcon, {
      name: $props.iconName,
      size: _ctx.size,
      viewbox: _ctx.viewbox
    }, null, 8, ["name", "size", "viewbox"])
  ], 8, _hoisted_1))
}
}

})